<template>
    <div class="row d-flex flex-row justify-content-center">
        <div class="search-wrap position-absolute">
            <transition name="fade">
                <div v-if="studentChosen" key="reason">
                <div class="search-input d-flex">
                    <input class="search-box" v-model="submittedInfraction" maxlength="34" type="text"  placeholder="Which infraction?" v-on:keyup.enter="submitInfraction"/>
                <button class="btn btn-secondary btn-sm d-flex align-self-stretch align-items-center rounded-0" @click="submitInfraction" :disabled="isSending">report</button>
                </div>
                <a href="#" class="no-underline" @click="resetForm">not {{ selectedStudent }}?</a></div>
          
                <div v-else key="student">
                <div class="search-input" v-bind:class="{'border-bottom-0': suggestionsExist}">
                    <input class="search-box" v-model="searchString" @keyup="filterStudents" type="text" maxlength="50" placeholder="Which student?"/>
                </div>
                <div class="search-autocomplete" v-show="suggestionsExist">
                    <div v-for="student in filteredStudents" :key="student.id" class="search-result d-flex mr-auto pl-2" style="width:100%;" @click="selectStudent(student)">
                        {{ student }}<br>
                    </div>
                </div>
                </div>
            </transition>
        </div>
        <div id="spacer" style="height:65px;"></div>
    </div>
</template>


<script>
import Firebase from 'firebase/app'
import { db } from '@/main.js'

export default {
    name: "StudentSearch",
    data () {
        return {
            studentIndex: {},
            searchString: "",
            filteredStudents: [],
            selectedStudent : "",
            submittedInfraction: "",
            isSending: false,
        }
    },
    methods: {
        filterStudents: function () {
            this.filteredStudents = (this.searchString.length > 2) ? this.studentIndex.studentArray.filter(
                student => student.toLowerCase().includes(this.searchString.toLowerCase())) : []
            
        },
        selectStudent: function (student) {
            this.selectedStudent = student
        },
        resetForm: function () {
            this.searchString = ""
            this.selectedStudent = ""
            this.submittedInfraction = ""
            this.filteredStudents = []
        },
        getDateStr: function () {
            var today = new Date(Date.now())
            var month = today.getMonth() + 1
            var date = today.getDate()
            return `${month}/${date}`
        },
        submitInfraction: async function () {
            if (this.submittedInfraction.length > 0) {
                this.isSending = true
                var nameIndex = this.studentIndex.studentArray
                const i = nameIndex.indexOf(this.selectedStudent)
                const studentId = this.studentIndex.idArray[i]

                var detentionRef = await db.collection('detentions').doc(studentId).get()
                if (detentionRef.exists) {
                    await detentionRef.ref.update({
                        infractionRecord: Firebase.firestore.FieldValue.arrayUnion(this.stampedInfraction())
                    })
                } else {
                    detentionRef.ref.set({
                        student: db.collection('students').doc(studentId),
                        infractionRecord: Firebase.firestore.FieldValue.arrayUnion(this.stampedInfraction()),
                        org: this.$root.sharedState.org
                    })
                }

                var studentRef = db.collection('students').doc(studentId);
                studentRef.update({
                    infractions: Firebase.firestore.FieldValue.arrayUnion(this.stampedInfraction()),
                    infractionCounter: Firebase.firestore.FieldValue.increment(1)
                })
                .then(() => {
                    console.log("infraction added")
                    this.resetForm();
                    this.isSending = false
                })
                .catch((error) => {
                    console.log(error)
                    this.isSending = false
                    })
                this.$toasted.show("Student reported")
            }
        },
        stampedInfraction: function () {
            var splitUser = this.$root.sharedState.username.split(' ')
            var userLast = splitUser.slice(splitUser.length - 1)
            return `${this.submittedInfraction}: ${userLast} ${this.getDateStr()}`
        },
    },
    computed: {
        suggestionsExist: function () {
            return this.filteredStudents.length > 0
        },
        studentChosen: function () {
            return this.selectedStudent.length > 0
        },
    },
    created () {  
        var indexRef = db.collection('index');
        var query = indexRef.where("org", "==", this.$root.sharedState.org).limit(1)
        query.get().then(snapshot => {
            snapshot.forEach(index => {
                this.studentIndex = index.data()
            })
        })
    }
}
</script>
